import { PostHog } from "posthog-js";
import { LoaderFunctionArgs } from "react-router";
import { canAccessMemberSetupFlow } from "~/shared/lib/posthog/posthog.helper";
import { notFound } from "~/shared/util/notFound";

export function participantCreateAccountViewLoader({ request }: LoaderFunctionArgs, posthogClient?: PostHog) {
  if (!canAccessMemberSetupFlow(posthogClient)) {
    return notFound();
  }

  const url = new URL(request.url);
  const token = url.searchParams.get("token");

  if (!token) {
    return notFound();
  }

  return null;
}
